import { ArrowUpRight } from "lucide-react";
import { BRANDS, BRAND_LOGOS } from "@/lib/site";

export default function Brands() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="brands"
      data-testid="brands-section"
      className="relative py-24 md:py-32 bg-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-amber-500" />
              <span className="font-tech text-amber-400 text-xs">OUR FAMILY OF BRANDS</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-3xl">
              <span className="chrome-text">Three Divisions.</span>
              <br />
              <span className="gold-text">One Standard.</span>
            </h2>
          </div>
          <p className="font-body text-slate-400 max-w-md">
            Each brand is engineered for a specific market — managed by specialists who
            live and breathe their vertical.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {BRANDS.map((b, idx) => (
            <article
              key={b.key}
              data-testid={`brand-card-${b.key}`}
              className="tracing-beam group"
              style={{ "--angle": `${idx * 120}deg` }}
            >
              <div className="p-6 md:p-8 flex flex-col h-full">
                <div className="aspect-square w-full mb-6 overflow-hidden rounded-sm border border-white/5 bg-black/30">
                  <img
                    src={BRAND_LOGOS[b.logo]}
                    alt={b.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                <div className="font-tech text-[10px] text-orange-400 mb-2">
                  DIVISION 0{idx + 1}
                </div>
                <h3 className="font-display text-2xl md:text-[1.65rem] tracking-tight chrome-text leading-tight mb-2">
                  {b.name}
                </h3>
                <p className="font-tech text-[11px] text-amber-400/80 mb-4">{b.tagline}</p>

                <p className="font-body text-slate-400 text-sm leading-relaxed mb-5">
                  {b.description}
                </p>

                <div className="mb-5 pt-4 border-t border-white/5">
                  <div className="font-tech text-[10px] text-slate-500 mb-2">FOCUS AREAS</div>
                  <div className="flex flex-wrap gap-2">
                    {b.focus.map((f) => (
                      <span
                        key={f}
                        className="font-tech text-[10px] px-2.5 py-1 border border-slate-700 text-slate-300"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mt-auto pt-4 border-t border-white/5 flex items-center justify-between">
                  <span className="font-tech text-[10px] text-slate-400">{b.manager}</span>
                  <button
                    onClick={() => scrollTo("request")}
                    className="text-orange-400 hover:text-orange-300 transition-colors"
                    aria-label={`Request ${b.name}`}
                    data-testid={`brand-cta-${b.key}`}
                  >
                    <ArrowUpRight size={20} />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
